import Backbone from 'backbone';
import ReactDOM from 'react-dom';
import React from 'react';
import { FocusLockBackboneInstanceWrapper } from './focus-lock-backbone-instance-wrapper';

export const focusLockInstanceDecorator =
  (instance, focusLockOptions, { managed, eventHandlers } = {}) => {
    const DecoratedFocusLockView = Backbone.View.extend({
      render() {
        ReactDOM.render(
          (
            <FocusLockBackboneInstanceWrapper
              focusLockProps={focusLockOptions}
              instance={instance}
              eventHandlers={eventHandlers}
              managed={managed}
            />
          ),
          this.el
        );

        return this;
      },

      remove() {
        ReactDOM.unmountComponentAtNode(this.el);
        Backbone.View.prototype.remove.call(this);
      },
    });

    return DecoratedFocusLockView;
  };
